import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-container"
};
const _hoisted_2 = {
  class: "about-title"
};
const _hoisted_3 = {
  class: "about-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Homehead = _resolveComponent("Homehead");
  const _component_blankBottom = _resolveComponent("blankBottom");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Homehead, {
    index: $data.index
  }, null, 8, ["index"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("text", null, _toDisplayString(_ctx.$t('messages.about_us_title')), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString(_ctx.$t('messages.about_us_detail')), 1)]), _createVNode(_component_blankBottom)]);
}